<ng-container *transloco="let t; read: TRANSALTION_SCOPE">
  <rx-applications-login-header [authConfig]="authConfig" />

  <rx-alert data-qa="test-auth-login-error" *ngIf="authFacade.error$ | async" type="danger" [message]="t('error.failed')"></rx-alert>

  @if (isSsoEnabled) {
    <div class="sso-wrapper">
      @if ((authFacade.isLoading$ | async)) {
        <rx-applications-loading-spinner data-qa="test-auth-login-with-sso-loading"/>
      } @else {
        <rx-button data-qa="test-auth-login-with-sso-button" buttonClass="primary" [flexible]="true"
                   (click)="onSsoLoginClick()" class="sso-button">
          {{ t('button.sso') }}
        </rx-button>
      }
    </div>
  } @else {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
      <div class="form-group" rxScrollToElement>
        <rx-input
          formControlName="username"
          type="email"
          [value]="usernameQueryParam"
          [placeholder]="t('form.label.emailPlaceholder')"
          [label]="t('form.label.email')"
        >
          <div rx-error>
            <div *ngIf="isFieldInvalid(form, 'username', 'required')">
              {{ t('error.emailMissing') }}
            </div>
            <div *ngIf="isFieldInvalid(form, 'username', 'email')">
              {{ t('error.emailInvalid') }}
            </div>
          </div>
        </rx-input>
      </div>

      <div class="form-group">
        <rx-input
          data-dd-privacy="mask-user-input"
          formControlName="password"
          type="password"
          [placeholder]="t('form.label.password')"
          [label]="t('form.label.password')"
        >
          <div rx-error>
            <div *ngIf="isFieldInvalid(form, 'password', 'required')">
              {{ t('error.passwordMissing') }}
            </div>
            <div *ngIf="isFieldInvalid(form, 'password', 'pattern')">
              {{ t('error.passwordInvalid') }}
            </div>
          </div>
        </rx-input>
      </div>

      <rx-button buttonClass="primary" type="submit" [flexible]="true" [disabled]="authFacade.isLoading$ | async">
        <span *ngIf="(authFacade.isLoading$ | async) === false; else isLoading">{{ t('button.active') }}</span>
        <ng-template #isLoading>{{ t('button.loading') }}</ng-template>
      </rx-button>
    </form>
    <div *ngIf="authConfig?.enableResetPassword" class="d-block w-100 text-right mt-2 f-size-xs">
      <a [routerLink]="addAbsolutePathPrefix(AuthRoutes.ForgotPassword)">
        {{ t('forgotPasswordLink') }}
      </a>
    </div>


    <hr class="border-top my-3" />

    <p *ngIf="authConfig?.selfSignup?.enableSelfSignup" class="f-size-xs mb-2">
      {{ t('signupPrefix') }}
      <a class="f-size-xs" [routerLink]="addAbsolutePathPrefix(AuthRoutes.Signup)">
        {{ t('signupLink') }}
      </a>
    </p>
  }
  <p
    class="f-size-xs mb-2"
    *ngIf="authConfig?.loginShowContactInfo && authConfig?.loginCustomHtml"
    [innerHTML]="
      t('contactInstructions', {
        name: authConfig?.loginContactName,
        email: authConfig?.loginContactEmail,
      })
    "
  ></p>
</ng-container>
